import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { _registerConfirm } from './confirm';

// Single global host for the in-app confirm dialog. Mounted once in App.
// Does NOT close on outside click — only the Cancel / Confirm buttons resolve it.
export default function ConfirmHost() {
  const [state, setState] = useState(null);
  useEffect(() => { _registerConfirm(setState); return () => _registerConfirm(null); }, []);
  if (!state) return null;

  const done = (val) => { try { state.resolve(val); } catch (_) {} setState(null); };
  const danger = state.danger !== false; // most confirms are destructive → default danger styling

  return createPortal(
    <div style={s.overlay}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <div style={s.title}>{state.title || 'Please confirm'}</div>
        <div style={s.msg}>{state.message}</div>
        <div style={s.actions}>
          <button style={s.cancel} onClick={() => done(false)}>{state.cancelText || 'Cancel'}</button>
          <button style={{ ...s.confirm, ...(danger ? s.confirmDanger : {}) }} onClick={() => done(true)}>
            {state.confirmText || 'Confirm'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

const s = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 6000, padding: 16 },
  modal: { background: '#fff', borderRadius: 16, padding: '22px 24px', width: 420, maxWidth: '94vw', boxShadow: 'var(--mc-e4)' },
  title: { fontSize: 17, fontWeight: 800, color: '#0f172a', marginBottom: 8 },
  msg: { fontSize: 14, color: '#475569', lineHeight: 1.5, whiteSpace: 'pre-wrap' },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 22 },
  cancel: { background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 9, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  confirm: { background: '#2563eb', color: '#fff', border: 'none', borderRadius: 9, padding: '10px 20px', fontSize: 14, fontWeight: 700, cursor: 'pointer' },
  confirmDanger: { background: '#dc2626' },
};
